import { TollStation } from "models/TollStation";
import { TollStationProps } from "models/types";
import { BaseServices } from "./baseServices";

export class TollStationService extends BaseServices<TollStationProps, TollStation> {
	constructor() {
		super(TollStation);
	}

	async listByConcessionaire(concessionaireId: string) {
		const params = {
			concessionaireId
		};
		return this.list("toll-stations", { params });
	}

	static getInstance() {
		return new TollStationService();
	}
}
